applications.classy.controller({
    name: 'ApplicationsController',
    inject: ['$scope', '$location', 'ApplicationService', 'CommitteeModeModalService', 'CommitteeModeModelService', 'ApplicationsSubNavbarService', 'RolloverWizardModalService',
        '$stateParams', 'AlertService', 'BinFactory', '$timeout', '$rootScope', 'authServiceFactory', '$http', 'TabsService', 'SchoolModelService', 'DateService', '$modal', 'EulaModalService'],
    init: function() {
        this.ApplicationService.setFamilyNo(0);
        this.$.versionNo = versionNo;
        this.$.$stateParams = this.$stateParams;
        this.$.ApplicationService = this.ApplicationService;
        this.$.ApplicationsSubNavbarService = this.ApplicationsSubNavbarService;
        this.$.BinFactory = this.BinFactory;  
        this.$.parent = this;
        this.item = this.CommitteeModeModelService.get()[0];
        if (this.SchoolModelService.get()[0].eula != 1 && (this.authServiceFactory.getAuth().isISMon == undefined || this.authServiceFactory.getAuth() == false))
            this.EulaModalService.initModal();

        //Rollover Wizard stuff
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        var aidYear = this.DateService.getCurrentYear();
        var lastAidYear = aidYear - 1;
        if (this.$.schoolinfo.lastLogin_FinYear == lastAidYear && this.$.$stateParams.applicationID == undefined) {
            this.authServiceFactory.getAuth().yearChangeOver = true;
            this.RolloverWizardModalService.initModal();
        }
        
        this.$.businessIncomeOpen = false;
        this.$.noteLeft = false;
        //this.$.MainContentService = this.MainContentService;
        this.$.TabsService = this.TabsService;
        this.$.CommitteeModeModelService = this.CommitteeModeModelService;
        this.$.CommitteeModeModalService = this.CommitteeModeModalService; 

        var t = this.item.startDate.split(/[- :]/);
        var u = this.item.startTime.split(/[- :]/);
        if (t[0] !== "0000")
            this.$.committeeDate =  new Date(t[0], t[1]-1, t[2], u[0], u[1], u[2]);
        this.$.committeeTime =  new Date();
        
        var floor = new Date(t[0], t[1]-1, t[2], u[0], u[1], u[2]);
        floor.setHours(Number(u[0])-2);
        floor.setMinutes(u[1]);
        var ceiling = new Date(t[0], t[1]-1, t[2], u[0], u[1], u[2]);
        ceiling.setHours(Number(u[0])+2);
        ceiling.setMinutes(u[1]);

        if (this.$.committeeTime > floor && this.$.committeeTime < ceiling) {
            if (this.item.active==0 && this.authServiceFactory.getAuth().loginType!=="COMMITTEE")
                this.CommitteeModeModalService.initModal(0);
            else if (this.item.active==0 && this.authServiceFactory.getAuth().loginType=="COMMITTEE")
                this.CommitteeModeModalService.initModal(4);
        }
        else if (this.$.committeeTime > ceiling && this.item.active==1) {
            this.item.active=0;
            this.item.startDate = '0000-00-00';
            this.item.startTime = '00:00:00';
            this.CommitteeModeModelService.put(this.authServiceFactory.getAuth().schoolID, this.item);
        }        
        else {
            this.item.active=0;
        }
    },
    //slide note modal to hide
    noteOpenLeft: function(value) {
        this.$.noteLeft = value;
        this.$rootScope.$broadcast('noteOpen',value);
    }
});